import { isReservedIntroducerSlug } from "./reservedSlugs";

/**
 * The JS twin of the backfill migration's SQL:
 *
 *     trim(both '-' from regexp_replace(lower(name), '[^a-z0-9]+', '-', 'g'))
 *
 * Both must produce the same slug for the same name, or an introducer created in the CRM
 * gets a different URL from one that existed at backfill time. `slugifyIntroducerName.test.ts`
 * pins the pair together with the same cases the migration was dry-run against.
 */
export const slugifyIntroducerName = (name: string): string =>
    name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

// Keeps the trailing hyphen slugifyIntroducerName strips, which per-keystroke would eat it as fast as it is typed
export const sanitiseTypedIntroducerSlug = (typed: string): string =>
    typed
        .toLowerCase()
        .replace(/[^a-z0-9-]+/g, "-")
        .replace(/-{2,}/g, "-")
        .replace(/^-+/, "");

const SLUG_SHAPE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export type TIntroducerSlugProblem = "empty" | "shape" | "reserved";

export const introducerSlugProblem = (slug: string): TIntroducerSlugProblem | null => {
    if (slug.trim() === "") {
        return "empty";
    }
    if (!SLUG_SHAPE.test(slug)) {
        return "shape";
    }
    if (isReservedIntroducerSlug(slug)) {
        return "reserved";
    }
    return null;
};
